import { IgTypography } from "@intelligems/ig-theme";
import { Skeleton, Stack } from "@mui/material";

import { formatMetricValue } from "../shared/utils/mobileAnalyticsFormatters";

import { BaseRendererProps } from "./types";

export const P2bcRenderer = ({
  variantData,
  selectedBaselineId,
  isLoading,
  currency,
}: BaseRendererProps) => {
  return (
    <Stack spacing={10} sx={{ paddingY: 5 }}>
      {variantData.map((variant) => {
        const isControl = variant.variation_id === selectedBaselineId;

        return (
          <Stack
            key={variant.variation_id}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <IgTypography>{variant.name}</IgTypography>
            {isLoading ? (
              <Skeleton variant="rectangular" width={60} height={24} />
            ) : (
              <IgTypography fontSize={17} fontWeight={600}>
                {isControl
                  ? "n/a"
                  : formatMetricValue(
                      variant.p2bc,
                      "percentNoDecimal",
                      currency
                    )}
              </IgTypography>
            )}
          </Stack>
        );
      })}
    </Stack>
  );
};
